import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-complete",
  "use": "icon-complete-usage",
  "viewBox": "0 0 22 22",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 22 22\" id=\"icon-complete\"><circle cx=\"11\" cy=\"11\" r=\"10\" fill=\"#fff\" stroke=\"#099\" stroke-width=\"2\" /><path fill=\"#099\" d=\"M9.5 13.1l-3.3-2.7L5 11.6l4.5 3.8 7.4-7.3L15.7 7l-6.2 6.1z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol